// extracted by mini-css-extract-plugin
export default {"defaultStyle":"TruncatableTypography_defaultStyle__pEdNn"};